import { api } from './client'
import { CreditSettings } from '../types'

export async function getSettings(): Promise<CreditSettings> {
  const res = await api.get('/api/v1/settings')
  return res.data
}

export async function updateSettings(data: Partial<{
  rate_3_months: number; rate_6_months: number
  rate_9_months: number; rate_12_months: number
  min_down_payment_pct: number; max_months: number
  usd_rate: number
  card_number: string; card_holder: string
  limit_bronze: number; limit_silver: number; limit_gold: number
  support_username: string
  surcharge_lt15_3m: number; surcharge_lt15_6m: number; surcharge_lt15_9m: number; surcharge_lt15_12m: number
  surcharge_lt10_3m: number; surcharge_lt10_6m: number; surcharge_lt10_9m: number; surcharge_lt10_12m: number
  surcharge_lt5_3m: number; surcharge_lt5_6m: number; surcharge_lt5_9m: number; surcharge_lt5_12m: number
}>): Promise<CreditSettings> {
  const res = await api.patch('/api/v1/settings', data)
  return res.data
}
